import { Font } from '@react-pdf/renderer'
import interBold from 'assets/fonts/inter/inter-v3-latin-600.ttf'
import interRegular from 'assets/fonts/inter/inter-v3-latin-regular.ttf'

export default () => {
  Font.register({
    family: 'Inter',
    fonts: [{ src: interRegular }, { src: interBold, fontWeight: 'bold' }],
  })
}
